// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { LinkedSystem, LinkedSystemAccLinkingValue } from '../misc/LinkedSystem';
import { DataCache } from '@shared/commons/DataCache';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { HotkeysManager } from '@shared/commons/cache/Hotkeys/HotkeysManager';
export class ApplicationPanelProps {
}
export class ApplicationPanelComponentView {
}
export class ApplicationPanelViewModel extends AbstractViewModel {
    get account() {
        return this.componentView.account;
    }
    set account(value) {
        this.updateComponentView('account', value);
    }
    constructor(componentView) {
        super(componentView);
        this.RefreshInstrumentDescriptions = this.RefreshInstrumentDescriptions.bind(this);
    }
    initialize(props) {
        var _a, _b, _c, _d, _e;
        super.initialize(props);
        (_a = props.onEvent) === null || _a === void 0 ? void 0 : _a.on('RefreshPanelsWithInstrumentDescriptions', this.RefreshInstrumentDescriptions);
        (_b = props.onEvent) === null || _b === void 0 ? void 0 : _b.on('openPanel', this.openPanel);
        (_c = props.onEvent) === null || _c === void 0 ? void 0 : _c.on('onHotKeyPressed', this.onHotKeyPressed);
        (_d = props.onEvent) === null || _d === void 0 ? void 0 : _d.on('getProperties', this.Properties);
        (_e = props.onEvent) === null || _e === void 0 ? void 0 : _e.on('callBack', this.callBack);
        this.oldProps = props;
    }
    update(props) {
        super.update(props);
        if (this.oldProps.symbolLinkValue !== props.symbolLinkValue) {
            this.symbolLink_Out(true);
        }
        if (this.oldProps.accountLinkValue !== props.accountLinkValue) {
            this.accountLink_Out(true);
        }
        if (this.oldProps.isAccountLinkShow !== props.isAccountLinkShow ||
            this.oldProps.isSymbolLinkShow !== props.isSymbolLinkShow) {
            this.LinkSystemHandler();
        }
        this.oldProps = props;
    }
    dispose() {
        var _a, _b, _c;
        super.dispose();
        (_a = this.oldProps.onEvent) === null || _a === void 0 ? void 0 : _a.off('RefreshPanelsWithInstrumentDescriptions', this.RefreshInstrumentDescriptions);
        (_b = this.oldProps.onEvent) === null || _b === void 0 ? void 0 : _b.off('openPanel', this.openPanel);
        (_c = this.oldProps.onEvent) === null || _c === void 0 ? void 0 : _c.off('onHotKeyPressed', this.onHotKeyPressed);
    }
    onKeyDown(e) {
        // TODO
    }
    themeChange() { }
    RefreshInstrumentDescriptions(insArray) { }
    openPanel(panelName) {
        const ins = this.getSelectedInstrumentID();
        MainWindowManager.Factory.addPanel(panelName, null, function (panel) {
            panel.symbolLink_In(ins);
        });
    }
    onHotKeyPressed(hotkey, event) {
        const result = this.hotkeyProcess(hotkey);
        if (result) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    hotkeyProcess(hotkey) {
        const hotkeyActionForPanel = HotkeysManager.GetActionByHotkeyForPanel(hotkey);
        if (hotkeyActionForPanel) {
            return true;
        }
        return false;
    }
    symbolLink_Out(newSubscriber, instrument) { }
    accountLink_Out(newSubscriber, account) {
        if (!isNullOrUndefined(account)) {
            LinkedSystem.setAccount(LinkedSystemAccLinkingValue, account.BstrAccount);
        }
        else if (LinkedSystem.accLinkingActive) {
            this.accountLink_In(LinkedSystem.getAccount(LinkedSystemAccLinkingValue));
        }
    }
    accountLink_In(accId, fromLinkedSystem = false) {
        if (!this.oldProps.canLinkByAccount) {
            return false;
        }
        if (fromLinkedSystem && !this.oldProps.isAccountLinkShow) {
            return false;
        }
        const acc = DataCache.Accounts[accId];
        if (!isNullOrUndefined(acc)) {
            this.account = acc;
        }
        this.oldProps.onAccountLink(acc);
        return true;
    }
    localize() {
        this.oldProps.onLocalize();
    }
    LinkSystemHandler(newVal, oldVal, key) {
        this.oldProps.onLinkSystemUpdated();
        if (!newVal && key === 'isAccountLinkShow') {
            if (!this.hasAccountLookup() && isNullOrUndefined(this.account)) {
                this.account = DataCache.getPrimaryAccount();
            }
        }
    }
    getAccount() {
        const account = this.account;
        return account !== null && account !== void 0 ? account : DataCache.getPrimaryAccount();
    }
    getSelectedInstrumentID() {
        return '';
    }
    Properties(properties) { }
    callBack(newProperties) { }
    cancelLastOrder(account, instrument, placedFrom) {
        const orders = DataCache.Trading.getOrdersByInstrumentAndAccount(instrument, account);
        let lastOrder = null;
        for (const order of orders) {
            if (isNullOrUndefined(lastOrder)) {
                lastOrder = order;
                continue;
            }
            if (order.UTCDateTime > lastOrder.UTCDateTime) {
                lastOrder = order;
            }
        }
        if (!isNullOrUndefined(lastOrder)) {
            void DataCache.FOrderExecutor.cancelOrdersPromise([lastOrder], false, placedFrom);
        }
    }
}
